/**
 * Reducers specify how the application's state changes in response to actions sent to the store.
 *
 * @see https://redux.js.org/basics/reducers
 */

import { createReducer } from 'reduxsauce';
import { StkIssSync02Types } from './Actions';
import INITIAL_STATE from './InitialState';

export const stkIssSync02ResetTimestamp = (state, { currentPage, sorts, filters, pageSize }) => ({
  ...state,
  currentPage: currentPage || state.currentPage,
  sorts: sorts || state.sorts,
  filters: filters || state.filters,
  pageSize: pageSize || state.pageSize,
  timestamp: Date.now()
  // selectedDocuments: INITIAL_STATE.selectedDocuments
});

export const stkIssSync02FetchStkIssSync02Loading = (state, { boolean }) => ({
  ...state,
  fetchIsLoading: boolean
});

export const stkIssSync02FetchStkIssSync02Success = (
  state,
  { documents, currentPage, lastPage, total, pageSize }
) => ({
  ...state,
  documents,
  currentPage,
  lastPage,
  total,
  pageSize
});

export const stkIssSync02AddSelectedDocuments = (state, { selectedDocuments }) => {
  const selectIds = state.selectedDocuments.map(value => value.id);
  return {
    ...state,
    selectedDocuments: [
      ...state.selectedDocuments,
      ...selectedDocuments.filter(data => {
        return !selectIds.includes(data.id);
      })
    ]
  };
};

export const stkIssSync02RemoveSelectedDocuments = (state, { selectedDocuments }) => {
  const selectIds = selectedDocuments.map(value => value.id);
  return {
    ...state,
    selectedDocuments: state.selectedDocuments.filter(data => {
      return !selectIds.includes(data.id);
    })
  };
};

export const stkIssSync02SetWorkspaceVisible = (state, { boolean }) => ({
  ...state,
  workspaceIsVisible: boolean
});

export const stkIssSync02SyncLoading = (state, { boolean }) => ({
  ...state,
  syncIsLoading: boolean
});

export const stkIssSync02SyncNowSuccess = state => ({
  ...state,
  timestamp: Date.now(),
  selectedDocuments: []
});

/**
 * @see https://github.com/infinitered/reduxsauce#createreducer
 */
export const reducer = createReducer(INITIAL_STATE, {
  [StkIssSync02Types.STK_ISS_SYNC02_RESET_TIMESTAMP]: stkIssSync02ResetTimestamp,
  [StkIssSync02Types.STK_ISS_SYNC02_FETCH_STK_ISS_SYNC02_LOADING]: stkIssSync02FetchStkIssSync02Loading,
  [StkIssSync02Types.STK_ISS_SYNC02_FETCH_STK_ISS_SYNC02_SUCCESS]: stkIssSync02FetchStkIssSync02Success,
  [StkIssSync02Types.STK_ISS_SYNC02_ADD_SELECTED_DOCUMENTS]: stkIssSync02AddSelectedDocuments,
  [StkIssSync02Types.STK_ISS_SYNC02_REMOVE_SELECTED_DOCUMENTS]: stkIssSync02RemoveSelectedDocuments,
  [StkIssSync02Types.STK_ISS_SYNC02_SET_WORKSPACE_VISIBLE]: stkIssSync02SetWorkspaceVisible,
  [StkIssSync02Types.STK_ISS_SYNC02_SYNC_LOADING]: stkIssSync02SyncLoading,
  [StkIssSync02Types.STK_ISS_SYNC02_SYNC_NOW_SUCCESS]: stkIssSync02SyncNowSuccess
});
